import Modal from './Modal';
import ButtonRow from './ButtonRow';
import ActionButton from './ActionButton';
import React, {useCallback} from 'react';
import {GridCol, HtmlGridForm, GridRow, GridSection} from './grid-form';
import RadioGroup from './RadioGroup';
import RadioButton from './RadioButton';
import icons from '../../markons/markons';
import css from './GroupBookingDialog.less';
import _ from 'lodash';
import AioText from './aio-inputs/AioText';
import type {FlightInfo} from '../models/Segment'
import {setKey} from '../util/collections'

interface FlightDetailsDialogProps {
    close: () => void
    value: FlightInfo
    onChange: (value: FlightInfo) => void
}

export default function FlightDetailsDialog({close, value: flight, onChange}: FlightDetailsDialogProps) {
    const inputText = useCallback((name) => ({
        value: _.get(flight, name, ''),
        onChange: (ev: any) => {
            onChange(setKey(flight, name, ev.target.value));
        },
    }), [flight, onChange]);

    const clearForm = useCallback(() => {
        onChange(Object.create(null));
        close();
    }, [close, onChange])

    return <Modal dialogClass={css.dialog}>
        <div className={css.titleBar}>Flight Info</div>
        <HtmlGridForm className={css.content}>
            <GridSection>
                <GridRow>
                    <GridCol>
                        <RadioGroup {...inputText('domestic')}>
                            <RadioButton value="INTERNATIONAL" icon={icons.faGlobeEurope}>International</RadioButton>
                            <RadioButton value="DOMESTIC" icon={icons.faGlobeAmericas}>Domestic</RadioButton>
                        </RadioGroup>
                    </GridCol>
                </GridRow>
                <GridRow>
                    <GridCol>
                        <RadioGroup {...inputText('departure')}>
                            <RadioButton value="DEPARTURE" icon={icons.faPlaneDeparture}>Departure</RadioButton>
                            <RadioButton value="ARRIVAL" icon={icons.faPlaneArrival}>Arrival</RadioButton>
                        </RadioGroup>
                    </GridCol>
                </GridRow>
                <GridRow>
                    <GridCol>
                        <AioText label="Airline & Flight #" icon={icons.faPlane} {...inputText('number')}/>
                    </GridCol>
                </GridRow>
            </GridSection>


            <ButtonRow>
                <ButtonRow.Left>
                    <ActionButton className="btn-save" onClick={close}>Save & Close</ActionButton>
                </ButtonRow.Left>

                <ButtonRow.Right>
                    <ActionButton className="btn-delete" onClick={clearForm}>Clear</ActionButton>
                </ButtonRow.Right>
            </ButtonRow>
        </HtmlGridForm>
    </Modal>
}
